import { platform } from '@/shared/lib/platform/platform'

/** Flags de degradação PWA vs app nativo (Capacitor). Ver design §4.1. */
export const nativeFeatureFlags = {
  IS_LOCAL_AI_AVAILABLE: platform.canRunLocalAI(),
  IS_WEB_PUSH_SUPPORTED: platform.canReceiveWebPush(),
  IS_PWA_INSTALL_PROMPT_AVAILABLE: platform.canShowPwaInstallPrompt(),
  IS_NATIVE_PUSH_SUPPORTED: platform.isNative() && platform.getPlatform() === 'android',
  IS_BIOMETRIC_GATE_AVAILABLE: platform.isNative(),
  IS_ANATOMY_ATLAS_AVAILABLE: !platform.isNative(),
} as const

export type NativeFeatureFlags = typeof nativeFeatureFlags

/**
 * Rotas cuja página carrega WebLLM / Transformers.js (IA local).
 * Auditadas em T-FLAGS-02 — chat-ia usa nuvem como fallback e não entra aqui.
 */
export const LOCAL_AI_ROUTES = [
  '/doctor/settings/local-ai',
  '/settings/local-ai',
] as const

export type LocalAiRoute = (typeof LOCAL_AI_ROUTES)[number]

export const useNativeFeatureFlags = (): NativeFeatureFlags => nativeFeatureFlags
